import React from "react";
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import DashboardIndex from "../../components/dashboard";


const DashboardView = () => (
  <Container fluid className="main-content-container px-4 backend">

    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Overzicht" subtitle="Dirix B.V." className="text-sm-left" />
    </Row>


    <Row>
      <Col lg="12">
          <DashboardIndex />
       
      </Col>
    </Row>
  </Container>
);

export default DashboardView;
